// get all the line items
document.querySelectorAll(".order-summary__body tr").forEach((tr) => {
  applyMinMaxToLineItem(tr);
});

// function to set the min and max values for a line item
function applyMinMaxToLineItem(tr) {
  
  // variant title 
  const variantTitleElement = tr.querySelector(".selected-variant");
  if (!variantTitleElement) return;

  // since there might be combinations we split them by /
  const variantTitle = variantTitleElement.innerText.trim();
  const variantParts = variantTitle.split("/").map(part => part.trim());

  let min = 1;
  let max = null;

  // loop the parts and check if they contain - or +. this is how we know its the size
  variantParts.forEach(part => {
    if (part.includes("-")) {
      [min, max] = part.split("-").map(Number);
    } else if (part.includes("+")) {
      [min] = part.split("+").map(Number);
    }
  });

  // the quantity inputs
  const qtyInput = tr.querySelectorAll("input[data-line-key]");
  if (!qtyInput) return;

  if (qtyInput) {
    qtyInput.forEach(input=>{
      input.min = min;
      input.max = max;
      // input.value = Math.max(min, parseInt(qtyInput.value) || min);
      // if(input.value > max) {
      //   input.value = max;
      //   input.setAttribute("value", max);
      // }
      input.addEventListener("input", validateQuantity);
      updateLineItemButtonState(input);
    })
  }

}

// function to handle the states of the buttons 
function updateLineItemButtonState(qtyInput) {
  // we identify each button by getting the line key and get min, max and current value
  const dataLineKey = qtyInput.dataset.lineKey;
  const quantitySelector = qtyInput.closest("quantity-selector");
  const decreaseButton = quantitySelector.querySelector(`.quantity-selector__button.decrease-a[data-line-key-btn="${dataLineKey}"]`);
  const increaseButton = quantitySelector.querySelector(`.quantity-selector__button.increase-a[data-line-key-btn="${dataLineKey}"]`);
  
  const currentValue = parseInt(qtyInput.value, 10);
  const min = parseInt(qtyInput.min, 10);
  const max = qtyInput.max ? parseInt(qtyInput.max, 10) : null;

  // checks if we are in the lower limit
  if (currentValue <= min) {
    decreaseButton.style.cursor = "not-allowed";
    decreaseButton.removeAttribute("href");
  }
  
  // Checks if we are in the upper limit
  if (max !== null && currentValue >= max) {
    increaseButton.style.cursor = "not-allowed";
    increaseButton.removeAttribute("href");
  }
}

// Function to validate input values and show errors
function validateQuantity(event) {
  const input = event.target;
  const min = parseInt(input.min, 10);
  const max = input.max ? parseInt(input.max, 10) : null;
  const value = parseInt(input.value, 10);

  if (value < min) {
    input.setCustomValidity(`Minimum allowed quantity is ${min}.`);
    input.reportValidity(); // Show the built-in error popup
    input.value = min; // Reset to minimum allowed value
  } else if (max !== null && value > max) {
    input.setCustomValidity(`Maximum allowed quantity is ${max}.`);
    input.reportValidity(); // Show the built-in error popup
    input.value = max; // Reset to maximum allowed value
  } else {
    input.setCustomValidity(""); // Clear errors if the value is valid
  }
}
